import { __assign, __rest } from "tslib";
import React from 'react';
import VeltRecordingPreviewStepsDialogCameraButtonOffWireframe from './VeltRecordingPreviewStepsDialogCameraButtonOffWireframe/VeltRecordingPreviewStepsDialogCameraButtonOffWireframe';
import VeltRecordingPreviewStepsDialogCameraButtonOnWireframe from './VeltRecordingPreviewStepsDialogCameraButtonOnWireframe/VeltRecordingPreviewStepsDialogCameraButtonOnWireframe';
var VeltRecordingPreviewStepsDialogCameraButtonWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-recording-preview-steps-dialog-camera-button-wireframe", __assign({}, remainingProp), children));
};
VeltRecordingPreviewStepsDialogCameraButtonWireframe.On = VeltRecordingPreviewStepsDialogCameraButtonOnWireframe;
VeltRecordingPreviewStepsDialogCameraButtonWireframe.Off = VeltRecordingPreviewStepsDialogCameraButtonOffWireframe;
export default VeltRecordingPreviewStepsDialogCameraButtonWireframe;
